/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../shared/response-with-error-generic';
import { GetCompanyArticleResponseJson } from './get-company-article-response-json';
import { DefaultGetResult } from '../results/default-get-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';
import { ArticleDto } from '../models/article-dto';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class GetCompanyArticleResponse extends ResponseWithErrorGeneric<GetCompanyArticleResponseJson, DefaultGetResult> implements IResponseWithErrorGeneric<DefaultGetResult> {
  public articles: ArticleDto[];

  //<custom-body>
  constructor(response: HttpResponse<GetCompanyArticleResponse>) {
    super(response, DefaultGetResult.Error);
    if (this.result !== DefaultGetResult.Success) {
      return;
    }

    this.articles = this.body.articles;
  }
  //</custom-body>
}
